import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle, Home } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("checking"); // checking | paid | pending | error
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const res = await api.paymentStatus(sid);
        setInfo(res.data);
        if (res.data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(res.data.payment_status)) { setStatus("error"); return; }
      } catch { /* keep trying */ }
      tries += 1;
      if (tries > 8) { setStatus("pending"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sid]);

  return (
    <div className="min-h-[70vh] grid place-items-center px-6 py-20">
      <div className="bg-white rounded-3xl p-10 border border-slate-200 shadow-xl max-w-md w-full text-center" data-testid="payment-result">
        {status === "checking" && (<><Loader2 className="h-14 w-14 text-brandred animate-spin mx-auto mb-5" /><h2 className="font-head font-bold text-2xl text-navy">Confirming your payment…</h2><p className="text-slate-500 mt-2">Please wait, do not close this window.</p></>)}
        {status === "paid" && (<><CheckCircle2 className="h-16 w-16 text-brandteal mx-auto mb-5" /><h2 className="font-head font-extrabold text-2xl text-navy">Payment Successful!</h2><p className="text-slate-600 mt-2">Thank you. Your fee payment {info?.label ? `for ${info.label}` : ""} of ₹{info?.amount?.toLocaleString("en-IN")} has been received.</p></>)}
        {status === "pending" && (<><Loader2 className="h-14 w-14 text-gold mx-auto mb-5" /><h2 className="font-head font-bold text-2xl text-navy">Payment Processing</h2><p className="text-slate-600 mt-2">Your payment is still processing. If money was deducted, it will reflect shortly.</p></>)}
        {status === "error" && (<><XCircle className="h-16 w-16 text-brandred mx-auto mb-5" /><h2 className="font-head font-bold text-2xl text-navy">Something went wrong</h2><p className="text-slate-600 mt-2">We couldn't confirm this payment. Please try again or contact the office.</p></>)}
        <Link to="/" data-testid="payment-home-btn"><Button className="mt-7 bg-navy hover:bg-navy/90 text-white rounded-full px-6"><Home className="mr-1.5 h-4 w-4" /> Back to Home</Button></Link>
      </div>
    </div>
  );
}
